module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHAAs5eloTXAAAAM1JREFUWMPtlzEShCAMRU2OIuVWnmFb5a4LtWfYakvOghUzDBNAdAnMCLX6Hz8x8wPW2qnkCLUlXzBSQ8n34AyAL/pefsln9++rCCYLINRmc6IpmBxEFMDd+qp46EgMhAS4c+tSN5BD3DlJNTByiKcgcGp8kOv2MReQU5yaJc1K4Fxo3gMwf1ZW+8PZ0M9fMAAGwHMBjNTgxyjOGWCkhlECdHmNswx+PEM/QnNAhNmwrx6o7QKVjJFarWpAxGJ5n4tJF6vZVUf+vpzWXs8P0sWYZtA2OhMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/puyo_g.png
// module id = FLKx
// module chunks = 1